import { BaseModel } from "@blue-chip/core";

export default class State extends BaseModel {}
